/**
 * Created by iamso on 16.08.2021
 */

const GrowthFund = function () {
    cleverapps.EventEmitter.call(this);

    this.received = -1;
    this.levels = [];

    this.load();
    this.createLevels();

    cleverapps.user.on("recheckAvailable", this.onUserIncLvl.bind(this));
    cleverapps.exp.on("changeExp", this.onUserChangeExp.bind(this));

    if (this.isBought()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.FUND_DAU);
    }
};

GrowthFund.prototype = Object.create(cleverapps.EventEmitter.prototype);
GrowthFund.prototype.constructor = GrowthFund;

GrowthFund.prototype.isBought = function () {
    return this.received > -1;
};

GrowthFund.prototype.onUserChangeExp = function () {
    if (cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_REGULAR) {
        return;
    }

    const isActive = this.isActive();
    this.wantsAttention = this.wantsAttention || isActive && !this.wasActive;
    this.wasActive = isActive;
};

GrowthFund.prototype.onUserIncLvl = function () {
    if (cleverapps.gameLevel && cleverapps.gameLevel.withOwnLevel()) {
        return;
    }

    this.calcLevelsState();

    if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR && this.isActive()) {
        if (this.findByLevelNo(cleverapps.user.getVirtualLevel() - 1)) {
            this.wantsAttention = true;
        }
    }
};

GrowthFund.prototype.getProduct = function () {
    return Product.CreateById(GrowthFund.PRODUCT, { type: "growthFund" });
};

GrowthFund.prototype.buy = function () {
    const product = this.getProduct();
    product.buy(this.processBought.bind(this));
};

GrowthFund.prototype.processBought = function (success) {
    if (!success) {
        return;
    }

    this.buyTime = Date.now();
    this.received = 0;
    this.save();

    cleverapps.metrics.logEvent(cleverapps.EVENTS.FUND_BUY);

    this.trigger("updateState");
    this.trigger("bought");
};

GrowthFund.prototype.createLevels = function () {
    for (let level = GrowthFund.LEVELS.start; level <= GrowthFund.LEVELS.finish; level += GrowthFund.LEVELS.step) {
        this.levels.push({
            levelNo: level,
            reward: GrowthFund.LEVELS.rewards[level] || GrowthFund.LEVELS.rewards.default
        });
    }

    this.calcLevelsState();
};

GrowthFund.prototype.calcLevelsState = function () {
    this.levels.forEach(function (level) {
        if (level.levelNo > cleverapps.user.getVirtualLevel() - 1) {
            level.state = GrowthFund.STATE.INSUFFICIENT;
        } else if (level.levelNo <= this.received) {
            level.state = GrowthFund.STATE.RECEIVED;
        } else if (this.received > 0) {
            if (level.levelNo === this.received + GrowthFund.LEVELS.step) {
                level.state = GrowthFund.STATE.READY;
            } else {
                level.state = GrowthFund.STATE.WAITING;
            }
        } else if (level.levelNo === GrowthFund.LEVELS.start) {
            level.state = GrowthFund.STATE.READY;
        } else {
            level.state = GrowthFund.STATE.WAITING;
        }
    }, this);
};

GrowthFund.prototype.takeReward = function (level) {
    if (!this.buyTime || Date.now() - this.buyTime > cleverapps.parseInterval("10 minutes")) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.FUND_GOLD, {
            amount: this.findByLevelNo(level).reward
        });
    }

    this.received = level;
    this.calcLevelsState();
    this.trigger("updateState");
    this.save();
};

GrowthFund.prototype.findByLevelNo = function (level) {
    for (const i in this.levels) {
        if (this.levels[i].levelNo === level) {
            return this.levels[i];
        }
    }
};

GrowthFund.prototype.findFirst = function (state) {
    for (const i in this.levels) {
        if (this.levels[i].state === state) {
            return this.levels[i];
        }
    }
};

GrowthFund.prototype.isRewardReady = function () {
    return this.findFirst(GrowthFund.STATE.READY);
};

GrowthFund.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.GROWTHFUND, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("growthfund");
    }
};

GrowthFund.prototype.getInfo = function () {
    return this.received;
};

GrowthFund.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.GROWTHFUND);
    this.setInfo(data === undefined ? -1 : data);
};

GrowthFund.prototype.setInfo = function (data) {
    this.received = data;

    if (typeof data === "object") {
        this.received = -1;
        if (data.bought || data.lastReceived !== undefined) {
            this.received = data.lastReceived || 0;
        }
    }

    this.wasActive = this.isActive();
};

GrowthFund.prototype.updateInfo = function (serverData) {
    this.setInfo(serverData);
    this.save(true);

    this.calcLevelsState();
};

GrowthFund.prototype.isActive = function () {
    return this.isAvailable() || this.isBought();
};

GrowthFund.prototype.isAvailable = function () {
    return Boolean(connector.payments.getProduct(GrowthFund.PRODUCT)) && cleverapps.user.checkAvailable(cleverapps.config.availables.GROWTH_FUND);
};

GrowthFund.prototype.getAvailableLevel = function () {
    return cleverapps.humanReadableNumber({ floatLevel: cleverapps.config.availables.GROWTH_FUND.level });
};

GrowthFund.prototype.getTotalWaitingRewards = function () {
    let total = 0;
    this.levels.forEach((level) => {
        if ([GrowthFund.STATE.READY, GrowthFund.STATE.WAITING].indexOf(level.state) !== -1) {
            total += level.reward;
        }
    });

    return total;
};

GrowthFund.prototype.needsAttention = function () {
    return this.isBought() && this.isRewardReady() || this.wantsAttention;
};

// a fund already bought is not found on purpose: the receipt then falls back to the product's restore reward
GrowthFund.RestoreFind = function () {
    return cleverapps.growthFund && !cleverapps.growthFund.isBought() ? cleverapps.growthFund : undefined;
};

// the window first, the fund a second later, as the purchase does
GrowthFund.RestoreGive = function (growthFund) {
    Restorable.displayWindow("GrowthFundWindow", () => new GrowthFundWindow());
    cleverapps.timeouts.setTimeout(() => growthFund.processBought(true), 1000);
};

GrowthFund.PRODUCT = "growthFund";

GrowthFund.STATE = {
    INSUFFICIENT: 0,
    WAITING: 1,
    READY: 2,
    RECEIVED: 3
};

GrowthFund.LEVELS = {
    start: 1,
    finish: 49,
    step: 1,
    rewards: {
        default: 450,
        1: 550
    }
};

Restorable.BY_TYPE["growthFund"] = new Restorable({
    location: "main",
    find: GrowthFund.RestoreFind,
    give: GrowthFund.RestoreGive
});